import CategoriesCreate from './CategoriesCreate';
import CategoriesEdit from './CategoriesEdit';
// import CategoriesIcon from '@mui/icons-material/FormatListBulleted';
import CategoriesIcon from '@mui/icons-material/LibraryBooks';
import CategoriesList from './CategoriesList';

export default {
  list: CategoriesList,
  edit: CategoriesEdit,
  create: CategoriesCreate,
  icon: CategoriesIcon,
};
